import styled from '@rsos/theme/styled';

export const StyledConnectionIndicator = styled.div<{ connected: boolean }>`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin: 0 5px 0 auto;
  background-color: ${({ connected }) => (connected ? '#28a745' : '#dc3545')};
`;
